var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row justify-center mt-6 text-xl font-semibold"},[_vm._v("\n  "+_vm._s(_vm.header)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }